import type { ReactNode } from 'react';

type Tone = 'error' | 'success' | 'info' | 'warning';

const STYLES: Record<Tone, string> = {
  error: 'border-fail/40 bg-red-50 text-fail',
  success: 'border-ok/40 bg-green-50 text-ok',
  info: 'border-line bg-surface text-ink',
  warning: 'border-warn/40 bg-amber-50 text-warn',
};

/** Inline status message. Errors are announced immediately; others politely. */
export function Alert({
  tone = 'info',
  children,
  className = '',
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
      className={`rounded-lg border px-3 py-2 text-sm ${STYLES[tone]} ${className}`}
    >
      {children}
    </div>
  );
}
